/* src/app/auth/forgot/forgot.component.css */
.green-button {
  background-color: var(--green);
}
/*# sourceMappingURL=forgot.component.css.map */
